document.addEventListener('DOMContentLoaded', () => {
    popupInicio();
});

const popupInicio  = () => {
    const popup = document.getElementById('popup-inicio');
    const closeBtn = document.getElementById('close-popup-home');
    const openBtn = document.getElementById('open-popup-home');

    if (!popup || !closeBtn) return;

    // Sanitiza el contenido para evitar mostrar el "X" del HTML antiguo.
    const closeLabel = closeBtn.getAttribute('aria-label') || 'Cerrar';
    closeBtn.textContent = '';
    const closeLabelEl = document.createElement('span');
    closeLabelEl.className = 'screen-reader-text';
    closeLabelEl.textContent = closeLabel;
    closeBtn.appendChild(closeLabelEl);

    openBtn.addEventListener('click', () => {
        popup.classList.add('is-active');
    });

    closeBtn.addEventListener('click', () => {
        popup.classList.remove('is-active');
    });

    // Cerrar al hacer clic fuera del contenido
    popup.addEventListener('click', (e) => {
        if (e.target === popup) {
            popup.classList.remove('is-active');
        }
    });
}
